module.exports = __webpack_public_path__ + "img/angry-face-meme.cafc4aa3.png";